module.exports = __webpack_public_path__ + "img/img1.1859ef0a.jpg";